// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentCommTypeUpdateRequestModel {
    static getAttributeTypeMap() {
        return EnrollmentCommTypeUpdateRequestModel.attributeTypeMap;
    }
}
EnrollmentCommTypeUpdateRequestModel.discriminator = undefined;
EnrollmentCommTypeUpdateRequestModel.additionalProperties = false;
EnrollmentCommTypeUpdateRequestModel.attributeTypeMap = [
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "communicationTypes",
        "baseName": "communicationTypes",
        "type": "TCSCommunicationType"
    },
    {
        "name": "marketingCommunicationTypes",
        "baseName": "marketingCommunicationTypes",
        "type": "TCSCommunicationType"
    },
];
//# sourceMappingURL=enrollmentCommTypeUpdateRequestModel.js.map